module.exports = __webpack_public_path__ + "img/ic_close_survey.73726542.svg";